import { font } from "../../typography/baseStyling";

type Size = "xsmall" | "small" | "medium" | "large";

export const inputTextStyle: Record<
  Size,
  typeof font[keyof typeof font] & { padding: string }
> = {
  xsmall: {
    ...font.Caption,
    padding: "6px 8px",
  },
  small: {
    ...font.BodyS,
    padding: "11px 16px",
  },
  medium: {
    ...font.BodyM,
    padding: "16px 16px",
  },
  large: {
    ...font.HeadingL,
    padding: "20px 23px",
  },
};

export const textFieldHeight: Record<Size, number> = {
  xsmall: 28,
  small: 44,
  medium: 52,
  large: 70,
};
